module.exports = __webpack_public_path__ + "img/21.708e7447.jpg";